<div class="bg-white p-6 rounded-lg border border-slate-200 shadow-sm">
  <div class="flex justify-between items-center mb-2">
    <h3 class="text-lg font-bold text-slate-800">Your Balance</h3>
    <button class="text-slate-400 hover:text-slate-700">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"></path></svg>
    </button>
  </div>
  <p class="text-4xl font-bold text-slate-900 mb-4">$12,405.21</p>
  
  <div class="h-24 mb-6">
    <svg width="100%" height="100%" class="block">
      <g class="transform translate-y-1">
        @for (item of chartData(); track item.label; let i = $index) {
          @let barHeight = (item.value / maxVal()) * 88;
          <rect 
            [attr.x]="(i * 55) + '%'" 
            [attr.y]="96 - barHeight" 
            width="40%" 
            [attr.height]="barHeight" 
            rx="4"
            [class]="item.label === 'Income' ? 'fill-blue-400' : 'fill-slate-300'">
          </rect>
          <text [attr.x]="(i * 55) + 20 + '%'" y="92" class="text-[10px] fill-slate-500 text-center" text-anchor="middle">{{item.label}}</text>
        }
      </g>
    </svg>
  </div>

  <div class="grid grid-cols-2 gap-4">
    <button class="w-full bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-blue-700 transition-colors duration-200">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /></svg>
      <span>Add Money</span>
    </button>
     <button class="w-full bg-slate-100 text-slate-700 font-semibold py-3 px-4 rounded-lg flex items-center justify-center space-x-2 hover:bg-slate-200 transition-colors duration-200">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" /></svg>
      <span>Withdraw</span>
    </button>
  </div>
</div>
